import { Box, LinearProgress, Stack } from "@mui/material";

export default function Loader() {
  return (
    <Stack
      sx={{
        justifyContent: "center",
        alignItems: "center",
        gap: 6,
        height: "100dvh",
        backgroundColor: (theme) => theme.vars.palette.background.default,
      }}
    >
      <Box
        component="img"
        src={`/${import.meta.env.SIPPY_ICON}`}
        alt="Sippy, your way of communicating"
        sx={{ width: "auto", height: 100, display: "block" }}
      />
      <LinearProgress style={{ width: 300 }} />
    </Stack>
  );
}
